<template>
  <v-container fluid>
    <div v-if="loading" class="loading text-center">
      <v-progress-circular
        :size="70"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <h1 class="loading-titulo">Carregando</h1>
    </div>

    <v-row v-if="!loading" class="pt-0">
      <v-col cols="12">
        <section id="container" style="height: 750px" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as pbi from "powerbi-client";
import utilsStorage from "@/utils/storage";
import EmbedToken from "@/model/token/EmbedToken";

export default {
  name: "Relatorio",
  props: {
    titulo: { type: String, require: true },
    reportId: { titulo: String, require: true },
  },

  data() {
    return {
      loading: false,
    };
  },
  watch:{
    reportId(){
      this.obterRelatorioPowerBI(this.reportId);
    }
  },

  methods: {
    obterRelatorioPowerBI(reportId) {
      let token = new EmbedToken(utilsStorage.obterEmbedTokenNaStorage(reportId));
      this.montarRelatorio(token);
    },

    montarRelatorio(token) {
      const config = {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: token.accessToken,
        embedUrl: token.embedUrl,
        permissions: pbi.models.Permissions.All,
        settings: {
                // background: pbi.models.BackgroundType.Transparent,
                personalBookmarksEnabled: true,
                panes: {
                    bookmarks: {
                       visible: true
                    }
                }
            }
      };

      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      const dashboardContainer = document.getElementById("container");
      const dashboard = powerbi.embed(dashboardContainer, config);

      dashboard.off("loaded");

      dashboard.on("loaded", function () {
        console.log("Report load successful");
      });

      dashboard.off("rendered");

      dashboard.on("error", function () {
        this.dashboard.off("error");
      });
    },
  },
};
</script>
